/* Adventskalender PLUS XXL – Türchen 4 Handtücher: Galerie und Größen-Karten mit Foto je Farbe, Schritt „Stick hinzufügen“ mit Logo auf der Bordüre. Ergänzt sp-adv-deal-b.js. */
(function () {
  var el = document.querySelector('[data-spdl]');
  if (!el || el.dataset.towel) return;
  el.dataset.towel = '1';
  var EN = el.dataset.lang === 'en';
  var variants = []; try { variants = JSON.parse(el.querySelector('[data-spdl-variants]').textContent); } catch (e) {}
  var SIZES = [
    { w: 50, h: 100, de: 'Handtuch', en: 'Hand towel', use: EN ? 'Hands, guest WC, office' : 'Hände, Gäste-WC, Büro' },
    { w: 70, h: 140, de: 'Badetuch', en: 'Bath towel', use: EN ? 'Shower, gym, sports' : 'Dusche, Fitness, Sport' },
    { w: 100, h: 150, de: 'Badelaken', en: 'Bath sheet', use: EN ? 'Sauna, beach, spa' : 'Sauna, Strand, Wellness' }
  ];
  var HEX = { 'black': 1, 'bottle green': 1, 'dark grey (solid)': 1, 'french navy': 1, 'lemon': 1, 'lime': 1, 'orange': 1, 'red': 1, 'rope': 1, 'royal blue 241': 1, 'turquoise': 1, 'white': 1 };
  var cd = []; try { cd = JSON.parse(el.querySelector('[data-spdl-colordata]').textContent); } catch (e) {}
  var c0 = cd[0] && cd[0].n ? cd[0].n.toLowerCase() : 'black';
  var st = { size: 0, color: HEX[c0] ? c0 : 'black', pos: 'm', logo: null, open: false };
  var IMG = 'https://cdn.shopify.com/s/files/1/0555/9409/0791/files/island-hochkant-';
  function slug(n) { return n.toLowerCase().replace(/[()]/g, '').trim().replace(/\s+/g, '-'); }
  function photo(w, c) { c = c || st.color; return IMG + slug(HEX[c] ? c : 'black') + '.jpg?width=' + w; }
  function eur(n) { return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }

  /* Schritt 1: Größen-Karten */
  var f1 = el.querySelector('[data-spdl-opt="1"]');
  var pills = f1 ? Array.prototype.slice.call(f1.querySelectorAll('[data-spdl-val]')) : [];
  if (!f1 || pills.length !== 3) return;
  var wrap1 = f1.querySelector('.spdl__pills');
  var cards = document.createElement('div'); cards.className = 'sptw__cards';
  SIZES.forEach(function (z, i) {
    var min = Infinity;
    variants.forEach(function (v) { if (v.o1 === pills[i].dataset.spdlVal) min = Math.min(min, v.p / 119); });
    var b = document.createElement('button'); b.type = 'button'; b.className = 'sptw__card'; b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
    b.innerHTML = '<span class="sptw__fig"></span><span class="sptw__nm"></span><span class="sptw__dim"></span><span class="sptw__use"></span><span class="sptw__from"></span>';
    b.querySelector('.sptw__fig').appendChild(pic(z));
    b.querySelector('.sptw__nm').textContent = EN ? z.en : z.de;
    b.querySelector('.sptw__dim').textContent = z.w + ' × ' + z.h + ' cm';
    b.querySelector('.sptw__use').textContent = z.use;
    b.querySelector('.sptw__from').innerHTML = (EN ? 'from ' : 'ab ') + '<b>' + (isFinite(min) ? eur(Math.round(min * 100) / 100) : '') + '</b> ' + (EN ? 'net' : 'netto');
    b.addEventListener('click', function () {
      pills[i].click(); st.size = i;
      Array.prototype.forEach.call(cards.children, function (c, k) { c.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      draw();
    });
    cards.appendChild(b);
  });
  wrap1.hidden = true; wrap1.parentNode.insertBefore(cards, wrap1);
  var lg1 = f1.querySelector('.spdl__legend'); if (lg1) lg1.lastChild.textContent = EN ? 'Choose your size' : 'Größe wählen';

  /* Schritt 2: Stick hinzufügen (Logo-Fieldset nach oben holen) */
  var fl = el.querySelector('[data-spdl-file]').closest('fieldset');
  f1.parentNode.insertBefore(fl, f1.nextSibling);
  var nums = el.querySelectorAll('.spdl__step > .spdl__legend > b'); Array.prototype.forEach.call(nums, function (b, i) { b.textContent = i + 1; });
  var lgl = fl.querySelector('.spdl__legend'); if (lgl) lgl.lastChild.textContent = EN ? 'Add embroidery' : 'Stick hinzufügen';
  var box = document.createElement('div'); box.className = 'sptw__stick';
  box.innerHTML = '<button type="button" class="sptw__add" aria-expanded="false"><span class="sptw__plus">+</span><span><b></b><small></small></span><span class="sptw__incl"></span></button>' +
    '<div class="sptw__body" hidden><div class="sptw__prev"></div><div class="sptw__ctl"><p class="sptw__hint"></p><div class="sptw__pos" role="group"></div></div></div>';
  box.querySelector('.sptw__add b').textContent = EN ? 'Your logo as embroidery' : 'Dein Logo als Stick';
  box.querySelector('.sptw__add small').textContent = EN ? 'up to 8 × 5 cm on the smooth border, embroidery file included' : 'bis 8 × 5 cm auf der glatten Bordüre, Stickdatei inklusive';
  box.querySelector('.sptw__incl').textContent = EN ? 'included' : 'inklusive';
  box.querySelector('.sptw__hint').textContent = EN ? 'Upload your logo below. We embroider it on the smooth border.' : 'Lade unten dein Logo hoch. Wir sticken es auf die glatte Bordüre.';
  var pos = box.querySelector('.sptw__pos');
  [['l', EN ? 'Left' : 'Links'], ['m', EN ? 'Centre' : 'Mitte'], ['r', EN ? 'Right' : 'Rechts']].forEach(function (p) {
    var b = document.createElement('button'); b.type = 'button'; b.textContent = p[1]; b.dataset.p = p[0]; b.setAttribute('aria-pressed', p[0] === st.pos ? 'true' : 'false');
    b.addEventListener('click', function () { st.pos = p[0]; Array.prototype.forEach.call(pos.children, function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); draw(); });
    pos.appendChild(b);
  });
  fl.insertBefore(box, fl.querySelector('.spdl__file'));
  var add = box.querySelector('.sptw__add'), body = box.querySelector('.sptw__body');
  add.addEventListener('click', function () { st.open = !st.open; body.hidden = !st.open; add.setAttribute('aria-expanded', st.open ? 'true' : 'false'); box.classList.toggle('is-open', st.open); if (st.open) draw(); });
  var out = document.createElement('input'); out.type = 'hidden'; out.setAttribute('data-spdl-place-out', ''); fl.appendChild(out);
  var file = el.querySelector('[data-spdl-file]');
  file.addEventListener('change', function () {
    var f = file.files && file.files[0];
    st.logo = f && /^image\/(png|jpe?g|svg\+xml|webp|gif)$/.test(f.type) ? URL.createObjectURL(f) : null;
    if (f && !st.open) add.click(); else draw();
  });
  el.addEventListener('spdl:color', function (e) { if (e.detail && e.detail.n) { st.color = e.detail.n.toLowerCase(); draw(); } });

  /* Galerie: Hochkant-Foto je Farbe statt der gefalteten Packshots */
  var main = el.querySelector('[data-spdl-main]'), badge = el.querySelector('.spdl__main [data-sp-ai-badge]');
  var oldThumbs = Array.prototype.slice.call(el.querySelectorAll('[data-spdl-thumb]'));
  var tbox = oldThumbs[0] ? oldThumbs[0].parentNode : null, tnew = [];
  if (tbox) {
    oldThumbs.forEach(function (b) { b.remove(); });
    cd.forEach(function (c) {
      var k = c.n.toLowerCase(); if (!HEX[k]) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'spdl__thumb'; b.dataset.c = k;
      b.setAttribute('aria-label', c.n);
      var im = document.createElement('img'); im.src = photo(200, k); im.alt = ''; im.loading = 'lazy'; im.width = 100; im.height = 134; b.appendChild(im);
      b.addEventListener('click', function () { st.color = k; draw(); });
      tbox.appendChild(b); tnew.push(b);
    });
  }
  /* Großes Bild: eigene Bühne mit maßstäblichem Foto und Maßpfeilen */
  var stage = null, sImg = null, sSvg = null;
  if (main) {
    var mp = main.parentNode; if (getComputedStyle(mp).position === 'static') mp.style.position = 'relative';
    stage = document.createElement('div'); stage.className = 'sptw__stage';
    sImg = document.createElement('img'); sImg.alt = ''; stage.appendChild(sImg);
    sSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); stage.appendChild(sSvg);
    mp.appendChild(stage); main.style.visibility = 'hidden';
    if (window.ResizeObserver) new ResizeObserver(function () { layout(); }).observe(mp);
  }
  function layout() {
    if (!stage) return;
    var z = SIZES[st.size], W = stage.clientWidth, H = stage.clientHeight; if (!W || !H) return;
    var mL = W * 0.06, mR = W * 0.17, mT = H * 0.05, mB = H * 0.15, bw = W - mL - mR, bh = H - mT - mB;
    var asp = 0.747 * (z.w / z.h) / 0.57, dh = Math.min(bh, bw / asp), dw = dh * asp;
    var il = mL + (bw - dw) / 2, it = mT + (bh - dh) / 2;
    sImg.style.left = il + 'px'; sImg.style.top = it + 'px'; sImg.style.width = dw + 'px'; sImg.style.height = dh + 'px';
    var x0 = il + 0.157 * dw, x1 = il + 0.844 * dw, y0 = it + 0.05 * dh, y1 = it + 0.95 * dh;
    var hy = y1 + Math.max(14, H * 0.035), vx = x1 + Math.max(14, W * 0.035), a = 7;
    function ln(xa, ya, xb, yb) { return '<line x1="' + xa + '" y1="' + ya + '" x2="' + xb + '" y2="' + yb + '"/>'; }
    sSvg.setAttribute('width', W); sSvg.setAttribute('height', H); sSvg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    sSvg.innerHTML = '<g stroke="#111" stroke-width="1.5" fill="none" stroke-linecap="round">' +
      ln(x0, hy, x1, hy) + ln(x0, hy - 6, x0, hy + 6) + ln(x1, hy - 6, x1, hy + 6) +
      ln(x0 + a, hy - a / 1.6, x0, hy) + ln(x0 + a, hy + a / 1.6, x0, hy) + ln(x1 - a, hy - a / 1.6, x1, hy) + ln(x1 - a, hy + a / 1.6, x1, hy) +
      ln(vx, y0, vx, y1) + ln(vx - 6, y0, vx + 6, y0) + ln(vx - 6, y1, vx + 6, y1) +
      ln(vx - a / 1.6, y0 + a, vx, y0) + ln(vx + a / 1.6, y0 + a, vx, y0) + ln(vx - a / 1.6, y1 - a, vx, y1) + ln(vx + a / 1.6, y1 - a, vx, y1) + '</g>' +
      '<g font-weight="700" font-size="' + Math.max(12, Math.round(W * 0.024)) + '" fill="#111" letter-spacing=".04em">' +
      '<rect x="' + ((x0 + x1) / 2 - 34) + '" y="' + (hy - 11) + '" width="68" height="22" rx="11" fill="#78E6D0"/>' +
      '<text x="' + (x0 + x1) / 2 + '" y="' + (hy + 5) + '" text-anchor="middle">' + z.w + ' cm</text>' +
      '<rect x="' + (vx - 34) + '" y="' + ((y0 + y1) / 2 - 11) + '" width="68" height="22" rx="11" fill="#78E6D0"/>' +
      '<text x="' + vx + '" y="' + ((y0 + y1) / 2 + 5) + '" text-anchor="middle">' + z.h + ' cm</text></g>';
  }
  function setMain() {
    var cn = (cd.filter(function (c) { return c.n.toLowerCase() === st.color; })[0] || { n: '' }).n;
    if (sImg) { sImg.src = photo(1100); sImg.alt = (EN ? "Sol's Island towel in " : "Handtuch Island von Sol's in ") + cn + ', ' + SIZES[st.size].w + ' × ' + SIZES[st.size].h + ' cm'; layout(); }
    tnew.forEach(function (b) { b.classList.toggle('is-on', b.dataset.c === st.color); });
    if (badge) { badge.hidden = false; var tx = badge.querySelector('[data-sp-ai-text]'); if (tx && badge.dataset.textEdited) tx.textContent = badge.dataset.textEdited; }
  }

  function pic(z) {
    var im = document.createElement('img'); im.className = 'sptw__ph'; im.alt = ''; im.loading = 'lazy';
    im.src = photo(400); var hh = Math.round(z.h * 1.05); im.style.height = hh + 'px'; im.style.width = Math.round(hh * 0.747 * (z.w / z.h) / 0.57) + 'px'; return im;
  }
  var LX = { l: 22.6, m: 44.5, r: 66.5 };
  function draw() {
    Array.prototype.forEach.call(cards.children, function (b) { var im = b.querySelector('.sptw__ph'); if (im) im.src = photo(400); });
    setMain();
    if (!st.open) return;
    var z = SIZES[st.size];
    var p = box.querySelector('.sptw__prev'); p.innerHTML = '';
    var wrap = document.createElement('span'); wrap.className = 'sptw__pw';
    var big = document.createElement('img'); big.src = photo(900); big.alt = (EN ? z.en : z.de) + ' Island'; wrap.appendChild(big);
    var lg = document.createElement('span'); lg.className = 'sptw__lg'; lg.style.left = LX[st.pos] + '%';
    if (st.logo) { var li = document.createElement('img'); li.src = st.logo; li.alt = ''; lg.appendChild(li); lg.classList.add('has-logo'); }
    wrap.appendChild(lg); p.appendChild(wrap);
    var cap = document.createElement('p'); cap.className = 'sptw__cap';
    cap.textContent = (EN ? z.en : z.de) + ' ' + z.w + ' × ' + z.h + ' cm · ' + (EN ? 'logo on the border, ' : 'Logo auf der Bordüre, ') + pos.querySelector('[aria-pressed="true"]').textContent.toLowerCase();
    p.appendChild(cap);
    out.value = (EN ? 'Embroidery on the border, ' : 'Stick auf der Bordüre, ') + pos.querySelector('[aria-pressed="true"]').textContent.toLowerCase() + (EN ? ', up to 8 × 5 cm' : ', bis 8 × 5 cm');
  }
  draw();
})();
